export default (function () {
  // DEBUG functions

  // takes number, returns string
  // eslint-disable-next-line no-unused-vars
  var toDebugNum = function (num) {
    return String(num.toFixed(3));
  };

  // takes [number 1, number 2], returns string

  var toDebugPoint = function (num) {
    return ['(', num[0].toFixed(3), ',', num[1].toFixed(3), ')'].join('');
  };

  // takes {c1: [x1,y1], c2: [x2,y2], returns string
  // eslint-disable-next-line no-unused-vars
  var toDebugLine = function (line) {
    return [toDebugPoint(line.c1), '-', toDebugPoint(line.c2)].join('');
  };

  // takes [[x,y],[x,y],[x,y]], returns string
  // eslint-disable-next-line no-unused-vars
  var toDebugPolygon = function (p) {
    var debug = [];
    for (var i = 0, len = p.length; i < len; i++) {
      debug.push('(', +p[i][0].toFixed(3) + ',', +p[i][1].toFixed(3) + ')');
    }
    return debug.join('');
  };

  // takes [[x,y],[x,y],[x,y]], returns string
  // eslint-disable-next-line no-unused-vars
  var toDebugRoundPolygon = function (p) {
    var debug = [];
    for (var i = 0, len = p.length; i < len; i++) {
      debug.push('(', +Math.round(p[i][0]) + ',', +Math.round(p[i][1]) + ')');
    }
    return debug.join('');
  };

  // takes [r, theta], returns [x, y]
  var toCartesian = function (p) {
    var rad = (p[1] * Math.PI) / 180;
    return [p[0] * Math.cos(rad), p[0] * Math.sin(rad)];
  };

  // takes number and number, returns a distance
  var sideLength = function (x, y) {
    return Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
  };

  // takes [x1, y1] and [x2,y2], returns a number
  var distance = function (p1, p2) {
    return sideLength(p1[0] - p2[0], p1[1] - p2[1]);
  };

  //pts: [[x1, y1], [x2, y2], [x3, y3], [x4, y4], [x5, y5]]
  var centroid = function (pts) {
    var x = 0,
      y = 0;
    for (var i = 0, len = pts.length; i < len; i++) {
      x += pts[i][0];
      y += pts[i][1];
    }
    return [x / len, y / len];
  };

  // takes [[x1, y1], [x2, y2], [x3, y3], [x4, y4], [x5, y5]], returns area
  var area = function (pts) {
    var len = pts.length;
    if (len < 3) return 0;

    var p1 = pts[len - 1],
      p2 = pts[0],
      sum = p1[0] * p2[1] - p1[1] * p2[0];

    len -= 1;
    for (var i = 0; i < len; i++) {
      p1 = pts[i];
      p2 = pts[i + 1];

      sum += p1[0] * p2[1] - p1[1] * p2[0];
    }
    return Math.abs(sum / 2);
  };

  var Vec2 = function (x, y) {
    return [x, y];
  };

  var nsub = function (v1, v2) {
    return Vec2(v1[0] - v2[0], v1[1] - v2[1]);
  };

  // scalar cross product
  var perpdot = function (v1, v2) {
    return v1[0] * v2[1] - v1[1] * v2[0];
  };

  // takes [[x,y],[x,y],[x,y]] and [x,y], return true or false
  var pointInsideConvexPolygon = function (point, polyVerts) {
    for (let i = 0, len = polyVerts.length; i < len; i++) {
      var v1 = nsub(polyVerts[i], point),
        v2 = nsub(polyVerts[i + 1 > len - 1 ? 0 : i + 1], point),
        edge = nsub(v1, v2),
        x = perpdot(edge, v1);

      // If the point lies directly on an edge then count it as in the polygon
      if (x > 0) return false;
    }
    return true;
  };

  // returns a list of polygon numbers that do not contain the point
  // takes [[x,y],[x,y],[x,y]] and [x,y] and returns [2,4]
  var getPolygonsNotContainingPoint = function (polygons, point) {
    var outside = [];
    for (var i = 0, len = polygons.length; i < len; i++) {
      if (!pointInsideConvexPolygon(point, polygons[i])) outside.push(i);
    }
    return outside;
  };

  // takes [x1,y1], [x2,y2] and returns [m,b]
  var slopeIntercept = function (p1, p2) {
    var m = (p1[1] - p2[1]) / (p1[0] - p2[0]);
    return [m, p1[1] - m * p1[0]];
  };

  // takes a number and returns a number
  var noNegativeZero = function (n) {
    return 0 == n ? Math.abs(n) : n;
  };

  // takes [x1,y1] and returns hash string
  var hashPoint = function (pt) {
    var trun = [noNegativeZero(pt[0].toFixed(3)), noNegativeZero(pt[1].toFixed(3))];
    return JSON.stringify(trun);
  };

  var setPoint = function (aa, pt, value) {
    var key = hashPoint(pt);

    if (Object.prototype.hasOwnProperty.call(aa, key)) {
      aa[key].push(value);

      // * DEBUG *
      //console.log(key + " " + JSON.stringify(pt) + " " + value.lineIndex + " " + value.c1);
      // * DEBUG *
    } else {
      aa[key] = [value];

      // * DEBUG *
      // console.log(key + " " + JSON.stringify(pt) + " " + value.lineIndex + " " + value.c1 + " new");
      // * DEBUG *
    }
  };

  /*
    takes:
    {  c1: [x, y], point 1 of line in original cartesian coordinate system
        c2: [x, y], point 2 of line in original cartesian coordinate system
        m: , slope of line segment in original cartesian coordinate system
        b: , y - intercept of line segment in original cartesian coordinate system
    }

    and

    {  c1: [x, y], point 1 of line in original cartesian coordinate system
        c2: [x, y], point 2 of line in original cartesian coordinate system
        m: , slope of line segment in original cartesian coordinate system
        b: , y - intercept of line segment in original cartesian coordinate system
    }

    and 
    
    []

    It is assumed that c1 is less than c2 with respect to the x coordinate

    returns true if line segments intersect then int is intercept [x,y]
    returns false otherwise
    */
  var intercept = function (l1, l2, int) {
    if (l1.m == l2.m) return false;

    var x = (l2.b - l1.b) / (l1.m - l2.m);

    if (x < l1.c1[0] || x < l2.c1[0] || x > l1.c2[0] || x > l2.c2[0]) return false;

    int.push(x);
    int.push(l1.m * x + l1.b);
    return true;
  };

  /*
    takes:
    {  c1: [x, y], point 1 of line in original cartesian coordinate system
        c2: [x, y], point 2 of line in original cartesian coordinate system
        m: , slope of line segment in original cartesian coordinate system
        b: , y - intercept of line segment in original cartesian coordinate system
    }

    and

    {  c1: [x, y], point 1 of line in original cartesian coordinate system
        c2: [x, y], point 2 of line in original cartesian coordinate system
        m: , slope of line segment in original cartesian coordinate system
        b: , y - intercept of line segment in original cartesian coordinate system
    }

    and 
    
    []

    It is assumed that c1 is less than c2 with respect to the x coordinate

    returns true if line segments intersect then int is intercept [x,y]
    returns false otherwise
    */
  var interceptVertical = function (l1, l2, int) {
    if (!isFinite(l2.m)) return false;

    var x = l1.c1[0],
      y = l2.m * x + l2.b,
      min = Math.min(l1.c1[1], l1.c2[1]),
      max = Math.max(l1.c1[1], l1.c2[1]);

    if (y < min || y > max || x < l2.c1[0] || x > l2.c2[0]) return false;

    int.push(x);
    int.push(y);
    return true;
  };

  var interceptVerticalFlip = function (l1, l2, int) {
    return interceptVertical(l2, l1, int);
  };

  var averagedCenter = function (polygons) {
    var x = 0,
      y = 0,
      n = 0,
      len = polygons.length;

    if (0 === len) return [0, 0];

    for (var i = 0; i < len; i++) {
      var poly = polygons[i];

      for (var j = 0, jlen = poly.length; j < jlen; j++) {
        x += poly[j][0];
        y += poly[j][1];
        n++;
      }
    }

    return [x / n, y / n];
  };

  /*
    Convert application data to format of algorithm
    takes model.currentPolygons with structure
    {
        inputSignal: [ [[x1,y1], [x2,y2], [x3,y3], [x4,y4], [x5, y5]] ],
        preAmplifierInput:  [ [[x1,y1], [x2,y2], [x3,y3], [x4,y4], [x5, y5]] ],
        debug: [ [[x1,y1], [x2,y2], [x3,y3], [x4,y4], [x5, y5]] ],
        preAmplifierOutput3Amp: [ [[x1,y1], [x2,y2], [x3,y3], [x4,y4], [x5, y5]] ],
        subtractorInputOutput: [ [[x1,y1], [x2,y2], [x3,y3], [x4,y4], [x5, y5]] ],
        outputAmplifier2Amp: [ [[x1,y1], [x2,y2], [x3,y3], [x4,y4], [x5, y5]] ],
        feedback1: [ [[x1,y1], [x2,y2], [x3,y3], [x4,y4], [x5, y5]] ],
        feedback2: [ [[x1,y1], [x2,y2], [x3,y3], [x4,y4], [x5, y5]] ],
        outputPinBoundry: [ [[x1,y1], [x2,y2], [x3,y3], [x4,y4], [x5, y5]] ]
    }

    x5 = x1 and y5 = y1 to close the polygon while plotting,
    so we can ignore the last point[x5, y5]

    returns

    {
            seg: [{  c1: [x, y],  point 1 of line in original cartesian coordinate system
                        c2: [x, y],  point 2 of line in original cartesian coordinate system
                        gon: number of polygon line segment is from       
                    }],                
            polygons: [ [[x1,y1], [x2,y2], [x3,y3], [x4,y4] ]
    };

    It is assumed that c1 is less than c2 with respect to the x coordinate
    */
  var polygon2LineSegmentData = function (polygons) {
    var segments = [],
      pointsForPolygons = [],
      polygonNumber = 0;

    for (var id in polygons) {
      if (!Object.prototype.hasOwnProperty.call(polygons, id)) continue;

      // do not consider these polygons for determining intersection
      if ('inputSignal' == id || 'debug' == id) continue;

      var poly = polygons[id][0];
      if (null == poly) {
        continue;
      }

      var polyPoints = [];
      for (var i = 0, len = poly.length - 1; i < len; i++) {
        segments.push({
          c1: poly[i],
          c2: poly[i + 1],
          gon: polygonNumber,
        });

        polyPoints.push(poly[i]);
      }

      if (polyPoints.length > 0) pointsForPolygons.push(polyPoints);

      polygonNumber++;
    }
    return {
      seg: segments,
      polygons: pointsForPolygons,
    };
  };

  /*
    takes
    [{  c1: [x, y], point 1 of line in original cartesian coordinate system
        c2: [x, y], point 2 of line in original cartesian coordinate system
        gon: number of polygon line segment is from       
    }]

    It is assumed that c1 is less than c2 with respect to the x coordinate

    returns
    [{  c1: [x, y], point 1 of line in original cartesian coordinate system
        c2: [x, y], point 2 of line in original cartesian coordinate system
        gon: number of polygon line segment is from
        m: slope of line segment in original cartesian coordinate system
        b: y - intercept of line segment in original cartesian coordinate system
        intersection: [[x, y]], intersecton point in original cartesian coordinate system
    }]

    It is assumed that c1 is less than c2 with respect to the x coordinate
    */
  var calculateIntersections = function (segments) {
    var len = segments.length;

    // calculate m , b, and lower and upper x boundries
    for (var i = 0; i < len; i++) {
      var seg = segments[i];
      var mb = slopeIntercept(seg.c1, seg.c2);

      seg.m = mb[0];
      seg.b = mb[1];
      seg.intersection = [];

      // c1 should be less that c2 along x
      if (seg.c1[0] > seg.c2[0]) {
        var temp = seg.c1;
        seg.c1 = seg.c2;
        seg.c2 = temp;
      }
    }

    // find intersections
    for (let i = 0; i < len; i++) {
      let seg = segments[i];

      for (var j = 0; j < len; j++) {
        var check = segments[j],
          inter = intercept;
        if (!isFinite(seg.m)) {
          inter = interceptVertical;
        } else if (!isFinite(check.m)) {
          inter = interceptVerticalFlip;
        }

        // lines of the same polygon can not intersect
        if (seg.gon == check.gon) continue;

        // intersection points are with respect to
        // shifted origin
        var int = [];
        if (inter(seg, check, int)) {
          seg.intersection.push(int);
          // * DEBUG *
          //console.log([toDebugLine(seg),
          //             ' & ',
          //             toDebugLine(check),
          //             ' intersects @ ',
          //             toDebugPoint(int),
          //             ' <-- {side ',
          //             String(i),
          //             ' from polygon ',
          //             String(seg.gon),
          //            '} with {side ',
          //             String(j),
          //             ' from polygon ',
          //             String(check.gon),
          //             '}'
          //             ].join(''));
          // * DEBUG *
        }
      }
    }
  };

  /*
    takes : [] and [x1,y1] and [x2,y2], pushes {c1:, c2:} into first argument
    if it represents a line rather than a point 
    */
  var pushIfLine = function (obj, pt1, pt2) {
    if (pt1[0] == pt2[0] && pt1[1] == pt2[1]) return;

    obj.push({ c1: pt1, c2: pt2 });
  };

  /*
    takes:
    [{  c1: [x, y], point 1 of line in original cartesian coordinate system
        c2: [x, y], point 2 of line in original cartesian coordinate system
        gon:         number of polygon line segment is from
        m: , slope of line segment in original cartesian coordinate system
        b: , y - intercept of line segment in original cartesian coordinate system
        intersection: [[x, y]], intersecton point in original cartesian coordinate system
    }]

    It is assumed that c1 is less than c2 with respect to the x coordinate

    returns
    [{  c1: [x, y], point 1 of divided line in original cartesian coordinate system
        c2: [x, y], point 2 of divided line in original cartesian coordinate system            
    }]
    */
  var breakLines = function (segs) {
    var lines = [];

    for (var i = 0, leni = segs.length; i < leni; i++) {
      var seg = segs[i],
        ins = seg.intersection,
        lenj = ins.length;

      if (0 === lenj) {
        lines.push({ c1: seg.c1, c2: seg.c2 });
        continue;
      }

      if (isFinite(seg.m))
        // sort the intersecting points in increasing x component
        seg.intersection.sort(function (a, b) {
          return a[0] - b[0];
        });
      else {
        // sort the intersecting points in increasing y component
        seg.intersection.sort(function (a, b) {
          return a[1] - b[1];
        });
        if (seg.c1[1] > seg.c2[1]) {
          var temp = seg.c1;
          seg.c1 = seg.c2;
          seg.c2 = temp;
        }
      }

      // Take care of the original endpoints of the side of the polygon
      pushIfLine(lines, seg.c1, ins[0]);
      pushIfLine(lines, ins[lenj - 1], seg.c2);

      // loop over what is left
      for (var j = 0; j < lenj - 1; j++) pushIfLine(lines, ins[j], ins[j + 1]);
    }
    return lines;
  };

  /*
    takes :
    [x, y] center,

    and

    [{  c1: [x, y], point 1 of divided line in original cartesian coordinate system
        c2: [x, y], point 2 of divided line in original cartesian coordinate system            
    }]

    returns

    [{  c1: [x, y], point 1 of divided line in original cartesian coordinate system
        c2: [x, y], point 2 of divided line in original cartesian coordinate system
        r1: radius, radial component of point 1 in polar coordinates base at shifted origin
        r2: radius, radial component of point 2 in polar coordinates base at shifted origin
    }]

    leaves c1 and c2 unchanged, theta is given in degrees

    */

  var sortByRadius = function (origin, pts) {
    for (var i = 0, len = pts.length; i < len; i++) {
      var pt = pts[i];
      pt.r1 = distance(pt.c1, origin);
      pt.r2 = distance(pt.c2, origin);
    }

    // Sort array so that the point of the line segment having the smaller distance,
    // to the shifted origin, is in increasing order.
    // Then the  first element of array will be the starting point of walking the graph.
    pts.sort(function (a, b) {
      return Math.min(a.r1, a.r2) - Math.min(b.r1, b.r2);
    });
  };

  /*
    takes

    [{  c1: [x, y], point 1 of divided line in original cartesian coordinate system
        c2: [x, y], point 2 of divided line in original cartesian coordinate system            
    }]

    returns

    ['pointkey'] = [{
                    lineIndex: index into line array,
                    c1:        true or false
                    }]

    */
  var constructGraph = function (lines) {
    var graph = [];
    for (var i = 0, len = lines.length; i < len; i++) {
      var line = lines[i];

      setPoint(graph, line.c1, { lineIndex: i, c1: true });
      setPoint(graph, line.c2, { lineIndex: i, c1: false });
    }
    return graph;
  };

  /*
    takes:

    [[{
        lineIndex: index into line array,
        c1:        true or false
    }]]

    and

    [{  c1: [x, y], point 1 of divided line in original cartesian coordinate system
        c2: [x, y], point 2 of divided line in original cartesian coordinate system
        r1: radius, radial component of point 1 in polar coordinates base at shifted origin
        r2: radius, radial component of point 2 in polar coordinates base at shifted origin
    }]

    and

    [x,y]

    returns

    [
    {c: [x, y], point in original cartesian coordinate system
        r: radial component of point in polar coordinates base at shifted origin}
    ]
    */
  var getWalkingPoints = function (graph, lines, point) {
    var key = hashPoint(point.c);
    var pts = graph[key];

    if (null == pts) {
      //debugger;
    }

    var wPts = [];
    var unique = [];
    for (var i = 0, len = pts.length; i < len; i++) {
      var pt = pts[i];
      var line = lines[pt.lineIndex];

      var dir = null;
      if (pt.c1)
        // then we would want to walk in direction of pt.c2
        dir = { c: line.c2, r: line.r2 };
      // then we would want to walk in direction of pt.c1
      else dir = { c: line.c1, r: line.r1 };

      // don't push the current point
      var ukey = hashPoint(dir.c);
      if (ukey == key) {
        continue;
      }

      // do not push duplicate destinations
      if (null == unique[ukey]) {
        wPts.push(dir);
        unique[ukey] = true;
      }
    }
    return wPts;
  };

  /*
    takes:
    {  c1: [x, y], point 1 of divided line in original cartesian coordinate system
        c2: [x, y], point 2 of divided line in original cartesian coordinate system
        r1: radius, radial component of point 1 in polar coordinates base at shifted origin
        r2: radius, radial component of point 2 in polar coordinates base at shifted origin
    }

    returns:

    {c: [x, y], point in original cartesian coordinate system
        r: radial component of point in polar coordinates base at shifted origin
        }
    */
  var pointofSmallerRadius = function (line) {
    return line.r1 < line.r2 ? { c: line.c1, r: line.r1 } : { c: line.c2, r: line.r2 };
  };

  // takes [x,y], [x,y], [x,y] and returns a number
  var curl = function (head1, head2, origin) {
    var v1 = [head1[0] - origin[0], head1[1] - origin[1]],
      v2 = [head2[0] - origin[0], head2[1] - origin[1]],
      c = v1[0] * v2[1] - v1[1] * v2[0];
    return c;
  };

  // takes [x,y], [x,y], [x,y] and returns a number
  var ang = function (head1, head2, origin) {
    var v1 = [head1[0] - origin[0], head1[1] - origin[1]],
      v2 = [head2[0] - origin[0], head2[1] - origin[1]],
      v1Len = Math.sqrt(Math.pow(v1[0], 2) + Math.pow(v1[1], 2)),
      v2Len = Math.sqrt(Math.pow(v2[0], 2) + Math.pow(v2[1], 2)),
      cosine = (v1[0] * v2[0] + v1[1] * v2[1]) / v1Len / v2Len;

    // correct for numeric rouning errors
    if (cosine < -1) cosine = -1;
    if (cosine > 1) cosine = 1;

    return (Math.acos(cosine) * 180) / Math.PI;
  };

  /*
    takes:

    [{  c1: [x, y], point 1 of divided line in original cartesian coordinate system
        c2: [x, y], point 2 of divided line in original cartesian coordinate system            
    }]

    and

    [[{
        lineIndex: index into line array,
        c1:        true or false
    }]]

    Assumes lines is sorted so that the point of the line segment having the smaller distance,
    to the shifted origin, is in increasing order.
    Then the first element of array will be the starting point of the walk around the graph.
    
    assending order of distance from shifted origin.
    This means the first element of lines is the place to begin constructing the 
    inner polygon.

    returns
            
    { poly: {c: [x, y], point in original cartesian coordinate system
                r: radial component of point in polar coordinates base at shifted origin}
            }, 
        area: a number
    }
    */
  var walkGraph = function (walk, debugWalk, center, lines, graph, startingPoint) {
    // * DEBUG *
    //if (walk == debugWalk)
    //    console.log("\nWALK: " + walk);
    // * DEBUG *

    //var innerPoly = [];
    var innerPolygon = [startingPoint.c];

    // loop until return to starting point
    var currentPt = startingPoint,
      previousPt = { c: center },
      FAIL = { poly: null, area: 0 };

    for (var t = 0; t < 16; t++) {
      // * DEBUG *
      //if (walk == debugWalk)
      //    console.log("Current location " + toDebugPoint(currentPt.c));
      // * DEBUG *

      var wPts = getWalkingPoints(graph, lines, currentPt);
      var best = null;
      for (var i = 0, len = wPts.length; i < len; i++) {
        var canPt = wPts[i];

        // check if we have reached home
        //if (canPt.c[0] === startingPoint.c[0] && canPt.c[1] === startingPoint.c[1] && t > 1) {
        if (hashPoint(canPt.c) == hashPoint(startingPoint.c) && t > 1) {
          innerPolygon.push(startingPoint.c);
          return {
            poly: [innerPolygon],
            area: area(innerPolygon),
          };
        }

        // At the same point
        if (currentPt.c[0] == canPt.c[0] && currentPt.c[1] == canPt.c[1]) {
          continue;
        }

        var c = curl(currentPt.c, canPt.c, center);

        // * DEBUG *
        //if (walk == debugWalk)
        //    console.log(toDebugPoint(currentPt.c) + " to " + toDebugPoint(canPt.c) + " curl " + toDebugNum(c));
        // * DEBUG *

        if (c > 0) {
          continue;
        }

        if (null == best) {
          best = canPt;
        } else {
          var canA = ang(previousPt.c, canPt.c, currentPt.c),
            bestA = ang(previousPt.c, best.c, currentPt.c);

          // * DEBUG *
          //if (walk == debugWalk)
          //    console.log("Candidate angle " + toDebugNum(canA) + ", smallest angle thus far " + toDebugNum(bestA));
          // * DEBUG *

          if (canA < bestA) {
            best = canPt;
          }
        }
      }
      if (null == best) {
        // * DEBUG *
        //console.log('Unable to walk further in clockwise direction');
        // * DEBUG *

        return FAIL;
      }

      // * DEBUG *
      //if (walk == debugWalk)
      //    console.log("Walking to " + toDebugPoint(best.c));
      // * DEBUG *

      innerPolygon.push(best.c);
      previousPt = currentPt;
      currentPt = best;
    }

    // * DEBUG *
    //console.log('path: ' + walk + ' lost\n\trounded:' + toDebugRoundPolygon(innerPolygon) + '\n\tactual: ' + toDebugPolygon(innerPolygon));
    // * DEBUG *

    return FAIL;
  };

  /*
    polygons:
    {
        inputSignal: [ [[x1,y1], [x2,y2], [x3,y3], [x4,y4], [x5, y5]] ],
        preAmplifierInput:  [ [[x1,y1], [x2,y2], [x3,y3], [x4,y4], [x5, y5]] ],
        debug: [ [[x1,y1], [x2,y2], [x3,y3], [x4,y4], [x5, y5]] ],
        preAmplifierOutput3Amp: [ [[x1,y1], [x2,y2], [x3,y3], [x4,y4], [x5, y5]] ],
        subtractorInputOutput: [ [[x1,y1], [x2,y2], [x3,y3], [x4,y4], [x5, y5]] ],
        outputAmplifier2Amp: [ [[x1,y1], [x2,y2], [x3,y3], [x4,y4], [x5, y5]] ],
        feedback1: [ [[x1,y1], [x2,y2], [x3,y3], [x4,y4], [x5, y5]] ],
        feedback2: [ [[x1,y1], [x2,y2], [x3,y3], [x4,y4], [x5, y5]] ],
        outputPinBoundry: [ [[x1,y1], [x2,y2], [x3,y3], [x4,y4], [x5, y5]] ]
    }

    startingPoints: [{ c: [x1,y1] }]
    */
  var getStartingPoints = function (polygons, startingPoints) {
    for (var id in polygons) {
      if (!Object.prototype.hasOwnProperty.call(polygons, id)) continue;

      // do not consider these polygons for determining intersection
      if ('inputSignal' == id || 'debug' == id) continue;

      var poly = polygons[id][0];
      if (null == poly) {
        continue;
      }

      var point = poly[0];
      if (null == point) {
        continue;
      }

      //var radius = sideLength(point[0], point[1]);
      var i = 1,
        len = poly.length;

      if (0 === len) {
        continue;
      }

      for (i = 1; i < len; i++) {
        startingPoints.push({ c: poly[i] });

        //var rad = sideLength(poly[i][0], poly[i][1]);
        //if (rad < radius) {
        //    radius = rad;
        //    point = poly[i];
        //}
      }
      startingPoints.push({ c: point });
      //startingPoints.push({ c: poly[i - 1] });
    }
    return startingPoints;
  };

  /*
    takes:  [ [[x1,y1], [x2,y2], [x3,y3], [x4,y4] ] and [x,y]
    returns: [x,y]
    */
  var adjustCenter = function (polygons, center) {
    var outside = getPolygonsNotContainingPoint(polygons, center);
    if (0 === outside.length) return;

    // * DEBUG *
    //if (0 !== outside.length) {
    //    console.log('center ' + center + ' is outside polygon numbers ' + JSON.stringify(outside));
    //}
    // * DEBUG *

    if (outside.length == 1) {
      var coid = centroid(polygons[outside[0]]);
      center[0] = (center[0] + coid[0]) / 2;
      center[1] = (center[1] + coid[0]) / 2;
    }

    outside = getPolygonsNotContainingPoint(polygons, center);
    // * DEBUG *
    //if (0 !== outside.length) {
    //    console.log('center ' + center + ' is outside polygon numbers ' + JSON.stringify(outside));
    //}
    // * DEBUG *

    if (0 == outside.length) return;

    for (var a = 0; a < 360; a++) {
      for (var r = 0.5; r < 160; r += 0.5) {
        var c = toCartesian([r, a]),
          p = [c[0] - center[0], c[1] - center[1]];

        if (getPolygonsNotContainingPoint(polygons, p).length == 0) {
          center[0] = p[0];
          center[1] = p[1];
          return;
        }
      }
    }

    // * DEBUG *
    //console.log('unable to find center');
    // * DEBUG *
  };

  return {
    // takes model.currentPolygons
    /**
     * What this is doing:
     * This finds the graph points/lines and starting points of each of the provided polygons.
     * For each starting point, the algorithm "walks" the lines until it finds the original starting point
     * or it has gone through a certain number of sets of walking points (currently 15).
     * If the original starting point is found, the polygon formed from the intersection of
     * all provided polygons is used for that starting point..
     * The intersection polygon with the smallest area (that is not a failure (0 or -1) is returned
     */
    intersect: function (polygons) {
      var segData = polygon2LineSegmentData(polygons),
        segs = segData.seg;

      var center = averagedCenter(segData.polygons);
      adjustCenter(segData.polygons, center);

      // * DEBUG *
      //console.log('using center: ' + center);
      // * DEBUG *

      calculateIntersections(segs);
      var lines = breakLines(segs);

      // * DEBUG *
      //console.log('line segments');
      //for (var i = 0, len = lines.length; i < len; i++) {
      //    var line = lines[i],
      //        p1 = JSON.stringify(line.c1),
      //        p2 = JSON.stringify(line.c2);

      //    console.log(i + " " + p1 + p2);
      //}

      sortByRadius(center, lines);

      var graph = constructGraph(lines);

      // * DEBUG *
      //console.log('LUT for graph');
      //for (var key in graph) {
      //    if (!graph.hasOwnProperty(key))
      //        continue;

      //    var value = graph[key];
      //    for (var i = 0, len = value.length; i < len; i++) {
      //        var o = value[i];
      //        console.log(key + " " + o.lineIndex + " " + o.c1);
      //    }
      //}

      var showDebugForWalk = 4;
      var startingPoints = [pointofSmallerRadius(lines[0])];
      var innerPolygon = walkGraph(0, showDebugForWalk, center, lines, graph, startingPoints[0]),
        chosenPath = 0; //eslint-disable-line no-unused-vars

      var singleWalk = false;

      // * DEBUG *
      //console.log('path: 0  area: ' + innerPolygon.area);
      // * DEBUG *

      if (!singleWalk) {
        getStartingPoints(polygons, startingPoints);
        for (var i = 1, len = startingPoints.length; i < len; i++) {
          var walk = walkGraph(i, showDebugForWalk, center, lines, graph, startingPoints[i]);

          // * DEBUG *
          //console.log('path: ' + i + ' area: ' + walk.area);
          // * DEBUG *

          if ((innerPolygon.area === 0 || walk.area < innerPolygon.area) && -1 != walk.area && walk.area > 1) {
            //chosenPath = i;
            innerPolygon = walk;
          }
        }

        // * DEBUG *
        //if (null != innerPolygon.poly)
        //    console.log('path: ' + chosenPath + ' inner polygon\n\trounded:' + toDebugRoundPolygon(innerPolygon.poly[0]) + '\n\tactual: ' + toDebugPolygon(innerPolygon.poly[0]));
        //else
        //    console.log('no inner polygon found');
        // * DEBUG *
      }

      return innerPolygon.poly;
    },
  };
})();
/*
        // currently not used

        // correct quadrant in degrees
        var atan3 = function (y, x) {
            var theta = Math.atan2(y, x) * 180 / Math.PI;
            return (theta < 0) ? theta + 360 : theta;
        };

        // takes [x,y], returns [r, theta]
        var toPolar = function (c) {
            var r = Math.sqrt(Math.pow(c[0], 2) + Math.pow(c[1], 2)),
                theta = atan3(c[1], c[0]);
            return [r, theta];
        };
        
        // takes [[{c:x, c:y}]] and returns a number
        var circumference = function (loop) {
            var cir = 0;
            for (var i = 0, len = loop.length; i < len; i++) {
                var s = loop[i];
                cir += sideLength(s[0], s[1]);
            }
            return cir;
        };
        
*/
